var map = {
	"./address_image.svg": 89,
	"./animated_ashutosh.png": 90,
	"./animated_lahiru.png": 91,
	"./animated_logo.svg": 92,
	"./aurecon.png": 93,
	"./aws.png": 94,
	"./blogs_image.svg": 95,
	"./cloud_infrastructure.svg": 96,
	"./codeInLogo.png": 97,
	"./contactMail.png": 98,
	"./coursera_logo.png": 99,
	"./data_science.svg": 100,
	"./deeplearning_ai_logo.png": 101,
	"./delhivery_logo.png": 102,
	"./developerActivity.svg": 103,
	"./dsc_logo.png": 104,
	"./dxc.png": 105,
	"./education.svg": 106,
	"./experience.svg": 107,
	"./feelingProud.png": 40,
	"./feelingProud.svg": 108,
	"./freecopy_logo.png": 109,
	"./fullstack.svg": 110,
	"./gcp_logo.png": 111,
	"./github_logo.png": 112,
	"./googleAssistant.jpg": 113,
	"./googleAssistant.svg": 114,
	"./google_logo.png": 115,
	"./hitachi.png": 116,
	"./ibm_logo.png": 117,
	"./iiitk_logo.png": 118,
	"./intel_logo.jpg": 119,
	"./iu_logo.png": 120,
	"./iu_logo2.png": 121,
	"./jsFramework.svg": 122,
	"./kubernetes.png": 123,
	"./legato_logo.png": 124,
	"./manOnTable.svg": 125,
	"./microsoft_logo.png": 126,
	"./mozilla_logo.png": 127,
	"./muffito_logo.png": 128,
	"./myriadlogo.jpg": 129,
	"./nextuLogo.jpg": 130,
	"./nptel_logo.png": 131,
	"./originEnergy.png": 132,
	"./portfolio.gif": 133,
	"./programmer.svg": 134,
	"./projects_image.svg": 135,
	"./pwa.png": 136,
	"./saayaHealthLogo.png": 137,
	"./snowflake.png": 138,
	"./stanford_logo.png": 139,
	"./talksCardBack.svg": 140,
	"./talksCardBackAlt.svg": 141,
	"./tiktok_logo.png": 142,
	"./ui_ux_design.svg": 143
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24;